module.exports = __webpack_public_path__ + "static/pot2-4c7ca93f3e56a36f569b40a47fe07ec8.svg";